import Axios from 'axios'
import config from '../../config/local-config'
import apiConfig from '../../config/api-config'

const ReviewsAPI = sku => {
  const apiUrl = `${config.getTurnToReviews}/${
    apiConfig.turnToKey
  }/${sku}/d/ugc/counts/en_US`
  return new Promise((resolve, reject) => {
    Axios.get(apiUrl, {
      withCredentials: false,
    })
      .then(response => {
        if (response) {
          resolve(response.data)
        } else {
          resolve(false)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}
export default ReviewsAPI
